<irembogov-time-picker
  [labelForId]="field.key"
  [customFormControl]="formControl"
  [endHour]="field.props['endHour']"
  [startHour]="field.props['startHour']"
  [interval]="field.props['interval']"
  [placeholder]="
    field.props.placeholder ? field.props.placeholder : ''
  "></irembogov-time-picker>
